import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DropdownComponent } from '../../ui/dropdown/dropdown';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item-two';
import { AuthStateService } from '../../../shared/states/auth.state';
import { AuthService } from '../../../shared/services/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-user-dropdown',
  imports: [
    CommonModule,
    RouterModule,
    DropdownComponent,
    DropdownItemTwoComponent
  ],
  templateUrl: './user-dropdown.html',
})
export class UserDropdown {
  isOpen = false;
  @Input() user!: any;
  @Output() dropdownOpened = new EventEmitter<void>();
  isLoggingOut = false;

  constructor(
    private authState: AuthStateService,
    private authService: AuthService
  ) {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.dropdownOpened.emit();
  }

  closeDropdown() {
    this.isOpen = false;
  }

  onSignOut() {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    const clientId = this.authState.getClientId();
    const redirectUrl = this.authState.getLogoutRedirectUrl();

    this.authService.logout(clientId ?? undefined)
      .pipe(finalize(() => { this.isLoggingOut = false; }))
      .subscribe({
        next: () => {
          this.authState.clearAuth();
          this.closeDropdown();
          if (typeof window !== 'undefined') {
            window.location.href = redirectUrl;
          }
        },
        error: () => {
          // Even if API fails, clear local auth to force re-login
          this.authState.clearAuth();
          this.closeDropdown();
          if (typeof window !== 'undefined') {
            window.location.href = redirectUrl;
          }
        }
      });
  }
}
